import { CountCellProps } from '../../types';

const ReplicaDatabaseToAgentCountsCell = ({ _customRowProps }: CountCellProps) => {
  return <div />;
};

export default ReplicaDatabaseToAgentCountsCell;
